import { BrowserContext, AppContext } from '../types';

export function getBrowserContext(): BrowserContext {
  try {
    return {
      user_agent: navigator.userAgent,
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      screen_width: screen.width,
      screen_height: screen.height,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  } catch (error) {
    console.warn('Failed to read browser context:', error);
    return {
      user_agent: navigator.userAgent || 'unknown',
      viewport_width: 0,
      viewport_height: 0,
      screen_width: 0,
      screen_height: 0,
      timezone: 'unknown',
    };
  }
}

export function getAppContext(): AppContext {
  try {
    const params = new URLSearchParams(window.location.search);
    const pathParts = window.location.pathname.split('/').filter(Boolean);

    return {
      site:
        params.get('siteId') || pathParts.find((_, i, arr) => arr[i - 1] === 'site') || undefined,
      building:
        params.get('buildingId') ||
        pathParts.find((_, i, arr) => arr[i - 1] === 'building') ||
        undefined,
      floor:
        params.get('floorId') || pathParts.find((_, i, arr) => arr[i - 1] === 'floor') || undefined,
    };
  } catch (error) {
    console.warn('Failed to read app context:', error);
    return {};
  }
}
